// extracted by mini-css-extract-plugin
export default {"Breadcrumb":"src-components-Antd-Breadcrumb-Breadcrumb__Breadcrumb--p6gWL"};